import styled from "styled-components";
import { theme } from "../theme";

export const StyledStatusInfo = styled.div`
	p {
		&:first-child {
			font-size: 0.8rem;
			font-weight: 500;
			font-family: ${theme.font.secondary};
			color: ${theme.color.gray};
			margin-bottom: 0.1rem;
			text-transform: uppercase;
		}
		&:last-child {
			font-size: 1.2rem;
			font-weight: 700;
			font-family: ${theme.font.secondary};
			color: ${theme.color.black};
		}
	}
`;
